<template>
  <b-container>
    <b-modal
      ref="modal-first-access"
      title="Primeiro Acesso"
      hide-footer
      size="xl"
      class="modal-first-access"
      header-bg-variant="secondary"
      header-text-variant="light"
    >
      <sp-form @onSubmit="submit" @onReset="reset">
        <b-row no-gutters>
          <b-col>
            <div class="modal-first-left">
              <p class="title">
                Seja bem vindo ao <br />
                Portal do Servidor Online <br />
                de {{ city }}
              </p>
              <p class="message">Você está acessando o portal pela primeira vez?</p>
              <p class="message">
                Precisamos confirmar alguns dados. Preencha os campos
                <br />
                ao lado e escolha uma senha para o seu acesso ao portal.
              </p>
              <p class="message bold">
                Observação: Sua senha deve conter no mínimo 6
                <br />
                caracteres contendo número e letras.
              </p>
            </div>
          </b-col>
          <b-col class="right">
            <sp-form-cpfcnpj mode="CPF" v-model="form.cpf" required />
            <sp-form-date label="Data de Nascimento" v-model="form.nascimento" required />
            <b-row no-gutters>
              <b-col>
                <sp-form-input
                  label="Senha"
                  type="password"
                  class="pr-2"
                  v-model="form.password"
                  rules="required"
                />
              </b-col>
              <b-col>
                <sp-form-input
                  label="Repita a Senha"
                  type="password"
                  v-model="form.passwordConfirmation"
                  rules="required"
                />
              </b-col>
            </b-row>
            <b-row no-gutters>
              <b-col cols="4" xl="5">
                <div style="margin-top: 8px" class="text-center">
                  <sp-captcha ref="captcha" />
                </div>
              </b-col>
              <b-col cols="8" xl="7">
                <sp-form-input
                  label="Insira o código da imagem ao lado"
                  v-model="form.captcha"
                  rules="required"
                  size
                />
              </b-col>
            </b-row>
            <b-row no-gutters class="mt-3">
              <b-col>
                <sp-button variant="secondary" class="w-90 b" type="reset">
                  <i class="fas fa-times"></i> Cancelar
                </sp-button>
              </b-col>
              <b-col>
                <sp-button class="w-90 b" type="submit" :loading="loading">
                  <i class="fas fa-sign-in-alt"></i> Avançar
                </sp-button>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </sp-form>
    </b-modal>
  </b-container>
</template>
<script>
import { firstAcessService } from '@/services';

export default {
  props: {
    city: String,
  },
  data() {
    return {
      form: firstAcessService.getBlankForm(),
      loading: false,
    };
  },
  methods: {
    show() {
      this.form = firstAcessService.getBlankForm();
      this.$refs['modal-first-access'].show();
    },
    reset() {
      this.$refs['modal-first-access'].hide();
    },
    setLoading(loading) {
      this.loading = loading;
    },
    submit() {
      try {
        firstAcessService.formValidation(this.form, this.$refs.captcha);
        const parsedForm = firstAcessService.parseToRequest(this.form);
        this.$emit('submit', parsedForm, this.setLoading, this.reset);
      } catch (error) {
        this.$alertify.error(error.message);
      }
    },
  },
};
</script>
<style lang="scss">
.modal-first-access {
  color: white;
}

.modal-first-left {
  .title {
    font-size: 30px;
  }
  .message {
    font-size: 14px;
  }
  .bold {
    font-weight: bold;
  }
}

.modal-first-acess .right {
}
</style>
